import { render, staticRenderFns } from "./NextInvoice.vue?vue&type=template&id=5b89ab49&"
import script from "./NextInvoice.vue?vue&type=script&lang=js&"
export * from "./NextInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports